import { Link } from "react-router-dom";

export default function PageHero({ eyebrow, title, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative pt-40 pb-24 md:pt-52 md:pb-28 overflow-hidden bg-[#0B162C] text-white">
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-40"/>
        <div className="absolute inset-0 hero-mask"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="eyebrow mb-6">{eyebrow}</div>
        <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.05] max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-6 max-w-2xl text-white/75 text-lg leading-relaxed">{subtitle}</p>}
        {crumbs.length > 0 && (
          <div className="mt-10 flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-white/60">
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-2">
                {c.to ? <Link to={c.to} className="hover:text-[#C5A059]">{c.label}</Link> : <span className="text-[#C5A059]">{c.label}</span>}
                {i < crumbs.length - 1 && <span>/</span>}
              </span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
